import get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';

import ListItem from './list-item';

/* eslint-disable react/jsx-no-bind */
class List extends React.Component {
	renderItem(index) {
		//const featureBefore = index > 0 ? this.props.features[index - 1] : null;
		const feature = this.props.features[index];
		//const letterBefore = get(
		//	featureBefore,
		//	'properties.name[0]',
		//	''
		//).toUpperCase();
		//const letter = get(feature, 'properties.name[0]', '').toUpperCase();

		return <ListItem key={feature.id} feature={feature} />;
		//return !featureBefore || letterBefore !== letter ? (
		//	<div className="bsknacht17-list__item" key={feature.id}>
		//		<h2 className="bsknacht17-list__headline bsknacht17-letter">
		//			{letter}
		//		</h2>
		//		<ListItem feature={feature} />
		//	</div>
		//) : (
		//	<ListItem key={feature.id} feature={feature} />
		//);
	}

	render() {
		return (
			<div className="bsknacht17-content__inner-wrapper bsknacht17-list">
				{this.props.features.length ? (
					this.props.features.map((_, index) =>
						this.renderItem(index)
					)
				) : (
					/* <ReactList
						scrollParentGetter={_ => window}
						length={this.props.features.length}
						itemRenderer={this.renderItem.bind(this)}
					/> */ <p className="bsknacht17-list__message">
						Keine Veranstaltungen gefunden.
					</p>
				)}
			</div>
		);
	}
}

List.propTypes = {
	features: PropTypes.array.isRequired,
	appStateHash: PropTypes.string.isRequired,
};

export default List;
